module.exports = __webpack_public_path__ + "img/innovate.ae9ad0fc.png";